import React from 'react';
import Bone, { StatCardBone, SectionHeaderBone } from './Bone';

/** Mirrors the dashboard: PageHeader, 4 KPI cards, 3 detail cards, then team + activity sections. */
export default function DashboardSkeleton() {
    return (
        <div aria-busy="true">
            {/* Page header */}
            <div className="mb-6">
                <Bone className="h-7 w-44" />
                <Bone className="mt-2 h-4 w-80 max-w-full" />
            </div>

            {/* KPIs */}
            <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 mb-4">
                {Array.from({ length: 4 }).map((_, index) => (
                    <StatCardBone key={index} />
                ))}
            </div>

            {/* Detail cards */}
            <div className="grid gap-4 grid-cols-1 lg:grid-cols-3 mb-4">
                {Array.from({ length: 3 }).map((_, index) => (
                    <StatCardBone key={index} footer />
                ))}
            </div>

            <div className="grid gap-4 grid-cols-1 lg:grid-cols-5">
                {/* Team */}
                <div className="shelf-card lg:col-span-2">
                    <SectionHeaderBone action={false} />
                    <div className="p-5">
                        <Bone className="h-7 w-16 mb-5" />
                        <div className="space-y-4">
                            {Array.from({ length: 4 }).map((_, index) => (
                                <div key={index}>
                                    <div className="flex items-center justify-between mb-2">
                                        <Bone className="h-3.5 w-20" />
                                        <Bone className="h-3.5 w-12" />
                                    </div>
                                    <Bone className="h-1.5 w-full rounded-full" />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Recent activity */}
                <div className="shelf-card lg:col-span-3">
                    <SectionHeaderBone />
                    <div className="divide-y divide-surface-100">
                        {Array.from({ length: 5 }).map((_, index) => (
                            <div key={index} className="flex items-center gap-3 px-5 py-3">
                                <Bone className="h-2 w-2 rounded-full shrink-0" />
                                <div className="flex-1 min-w-0 space-y-2">
                                    <Bone className="h-3.5 w-2/5" />
                                    <Bone className="h-3 w-1/4" />
                                </div>
                                <div className="flex flex-col items-end gap-1.5 shrink-0">
                                    <Bone className="h-5 w-20" />
                                    <Bone className="h-3 w-24" />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
